var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.item
    ? _c(
        "div",
        {
          staticClass: "card tile is-parent",
          class: _vm.computedClassName,
          style: _vm.computedStyle,
          attrs: { role: "article" },
        },
        [
          _vm.media
            ? _c(
                "div",
                { staticClass: "card-image tile is-child" },
                [
                  _vm.linkTo
                    ? _c(
                        "router-link",
                        {
                          staticClass: "card-link",
                          attrs: {
                            to: _vm.computedRoute,
                            event: "",
                            title: _vm.title,
                          },
                          nativeOn: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.onClick(_vm.item, $event)
                            },
                          },
                        },
                        [
                          _c(_vm.imageComponent, {
                            tag: "component",
                            attrs: {
                              item: _vm.item,
                              name: _vm.title,
                              src: _vm.computedImageSrc,
                              resolution: _vm.imageResolution,
                              "image-as-background": _vm.imageAsBackground,
                              "image-class-name": _vm.imageOrientation,
                              "image-alt-text": _vm.imageAltText,
                              social: _vm.socialImage,
                              "link-to": _vm.linkTo,
                              zoom: _vm.viewerZoom,
                              "use-masonry-sizing": _vm.useMasonrySizing,
                              "use-palette": _vm.usePalette,
                              "not-found-image-src": _vm.defaultImageSrc,
                            },
                            on: { click: _vm.onClick },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "image-tool-icons",
                                  fn: function (slotScope) {
                                    return [
                                      _vm._t("image-tool-icons", null, {
                                        item: slotScope.item,
                                      }),
                                    ]
                                  },
                                },
                                !_vm.showNotAvailable
                                  ? {
                                      key: "not-available",
                                      fn: function () {
                                        return [_c("span")]
                                      },
                                      proxy: true,
                                    }
                                  : null,
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      )
                    : _c(_vm.imageComponent, {
                        tag: "component",
                        attrs: {
                          item: _vm.item,
                          name: _vm.title,
                          src: _vm.computedImageSrc,
                          resolution: _vm.imageResolution,
                          "image-as-background": _vm.imageAsBackground,
                          "image-class-name": _vm.imageOrientation,
                          "image-alt-text": _vm.imageAltText,
                          social: _vm.socialImage,
                          "link-to": _vm.linkTo,
                          zoom: _vm.viewerZoom,
                          "use-masonry-sizing": _vm.useMasonrySizing,
                          "use-palette": _vm.usePalette,
                          "not-found-image-src": _vm.defaultImageSrc,
                        },
                        on: { click: _vm.onClick },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "image-tool-icons",
                              fn: function (slotScope) {
                                return [
                                  _vm._t("image-tool-icons", null, {
                                    item: slotScope.item,
                                  }),
                                ]
                              },
                            },
                            {
                              key: "not-available",
                              fn: function () {
                                return [_c("span")]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                  _vm._t("media"),
                ],
                2
              )
            : _vm._e(),
          _vm.header && _vm.linkTo && (_vm.item.Id || _vm.item.ActorId)
            ? _c(
                "div",
                { staticClass: "card-header" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "card-link",
                      attrs: {
                        to: _vm.computedRoute,
                        event: "",
                        title: _vm.title,
                      },
                      nativeOn: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.onClick(_vm.item, $event)
                        },
                      },
                    },
                    [_vm._t("header")],
                    2
                  ),
                ],
                1
              )
            : _vm.header
            ? _c(
                "div",
                { staticClass: "card-header no-link" },
                [_vm._t("header")],
                2
              )
            : _vm._e(),
          _vm.social
            ? _c(
                "div",
                { staticClass: "card-social" },
                [_vm._t("social-actions")],
                2
              )
            : _vm._e(),
          _vm.contents
            ? _c(
                "div",
                { staticClass: "card-contents tile is-child" },
                [
                  _vm._t("contents"),
                  _vm.showArticleLinks && _vm.item && _vm.item.ArticleLinks
                    ? _c("article-links", {
                        attrs: { "article-links": _vm.item.ArticleLinks },
                      })
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _vm.showCredits || _vm.showCopyright
            ? _c("div", { staticClass: "card-attribution" }, [
                _vm.showCredits && _vm.creditLine
                  ? _c(
                      "div",
                      { staticClass: "credit-line" },
                      [
                        _c("icon-taide-art", {
                          attrs: { white: _vm.className === "video-card" },
                        }),
                        _c("span", [_vm._v(_vm._s(_vm.creditLine))]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showCopyright && _vm.copyright
                  ? _c("div", { staticClass: "copyright" }, [
                      _vm.className === "audio-card"
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("audios.copyright") + " " + _vm.copyright
                              )
                            ),
                          ])
                        : _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("common.copyright") + " " + _vm.copyright
                              )
                            ),
                          ]),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }